
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("kaG0t", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudge", () => $68fdf06594851692$export$b05b391cfd27dc1c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7dRgX = parcelRequire("7dRgX");
var $dvYZ5 = parcelRequire("dvYZ5");
var $5cLMB = parcelRequire("5cLMB");

var $2LTOq = parcelRequire("2LTOq");

var $5e1YW = parcelRequire("5e1YW");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $82TTj = parcelRequire("82TTj");


var $4LQ2W = parcelRequire("4LQ2W");

var $8Uxmd = parcelRequire("8Uxmd");
const $68fdf06594851692$export$b05b391cfd27dc1c = ({ children: children })=>{
    (0, $82TTj.useTrackMountedNudgesController)((0, $99a775c02d636a41$export$e9e47a7ad42e71f5));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const shouldShowNudge = (0, $4LQ2W.useCanShowQuickstartNudge)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $5cLMB.useQuickstartActions)();
    const markComplete = (0, $dvYZ5.useMarkAsCompleteAndExpand)();
    const onFinishClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'finishNudgeButton clicked', {
            nudgeId: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5)
        });
        setHasNudgeActive(false, (0, $7dRgX.JWM_FEEDBACK_TASK));
        markComplete((0, $7dRgX.JWM_FEEDBACK_TASK));
    }, [
        createAnalyticsEvent,
        markComplete,
        setHasNudgeActive
    ]);
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5e1YW.QuickstartNudge), {
        nudgeId: (0, $99a775c02d636a41$export$e9e47a7ad42e71f5),
        itemNames: [
            (0, $7dRgX.JWM_FEEDBACK_TASK)
        ],
        nudgeSpotlightCardProps: {
            content: formatMessage((0, $8Uxmd.default).jwmFeedbackNudgeContentSpork),
            width: (0, $7dRgX.DEFAULT_NUDGE_WIDTH),
            position: (0, $2LTOq.POSITION_BOTTOM),
            actionsBeforeElement: '1/1',
            actions: [
                {
                    text: formatMessage((0, $8Uxmd.default).nudgeCtaFinish),
                    onClick: onFinishClick
                }
            ]
        }
    }, children);
};

});
parcelRegister("dvYZ5", function(module, exports) {

$parcel$export(module.exports, "useMarkAsCompleteAndExpand", () => $d937751600833074$export$5894bc689b58a859);

var $bFzGY = parcelRequire("bFzGY");

var $5cLMB = parcelRequire("5cLMB");

var $lIoQU = parcelRequire("lIoQU");
const $d937751600833074$export$5894bc689b58a859 = ()=>{
    const [completedTaskList, { nextMarkAsCompletedTask: nextMarkAsCompletedTask, nextAutoExpand: nextAutoExpand }] = (0, $5cLMB.useCompletedTaskList)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (taskId)=>{
        const taskAlreadyCompleted = completedTaskList.includes(taskId);
        if (taskAlreadyCompleted) return;
        nextMarkAsCompletedTask(taskId);
        (0, $lIoQU.fireAnalyticsOnChecklistItemCompleted)(createAnalyticsEvent, taskId);
        nextAutoExpand();
    };
};

});

parcelRegister("2LTOq", function(module, exports) {

$parcel$export(module.exports, "POSITION_RIGHT", () => $28d3e63caffaf69b$export$4ed9c122bcc20157);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $28d3e63caffaf69b$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_TOP_START", () => $28d3e63caffaf69b$export$3409cd2decbff80c);
$parcel$export(module.exports, "POSITION_TOP_END", () => $28d3e63caffaf69b$export$1a430e6e8a1cbf17);
$parcel$export(module.exports, "POSITION_BOTTOM_START", () => $28d3e63caffaf69b$export$663d1c5ad4215eb0);
$parcel$export(module.exports, "POSITION_BOTTOM_END", () => $28d3e63caffaf69b$export$9c417155181792ae);
$parcel$export(module.exports, "POSITION_RIGHT_START", () => $28d3e63caffaf69b$export$84a134a88de18270);
$parcel$export(module.exports, "POSITION_LEFT_END", () => $28d3e63caffaf69b$export$9ed28c4aa79d6398);
$parcel$export(module.exports, "DEFAULT_SCROLL_TO_NUDGE", () => $28d3e63caffaf69b$export$27ce92ea48cacd56);
const $28d3e63caffaf69b$export$b0758137ee643e7 = 'left';
const $28d3e63caffaf69b$export$4ed9c122bcc20157 = 'right';
const $28d3e63caffaf69b$export$cec9b06edc71d96c = 'bottom';
const $28d3e63caffaf69b$export$4fb34bdcd97adf85 = 'top';
const $28d3e63caffaf69b$export$3409cd2decbff80c = 'top-start';
const $28d3e63caffaf69b$export$1a430e6e8a1cbf17 = 'top-end';
const $28d3e63caffaf69b$export$663d1c5ad4215eb0 = 'bottom-start';
const $28d3e63caffaf69b$export$9c417155181792ae = 'bottom-end';
const $28d3e63caffaf69b$export$84a134a88de18270 = 'right-start';
const $28d3e63caffaf69b$export$b71f6a080452c5e8 = 'right-end';
const $28d3e63caffaf69b$export$b67243f02ceac890 = 'left-start';
const $28d3e63caffaf69b$export$9ed28c4aa79d6398 = 'left-end';
const $28d3e63caffaf69b$export$27ce92ea48cacd56 = {
    scrollIntoViewOptions: {
        inline: 'end',
        behavior: 'smooth'
    }
};

});

parcelRegister("5e1YW", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $43695f19b459f7b9$export$bd61ee610c74db6c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $ewdMq = parcelRequire("ewdMq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43695f19b459f7b9$var$LazyQuickstartNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4UsCN")).then((exportedModule)=>exportedModule.QuickstartNudge), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-quickstart-core/src/common/ui/quickstart-nudge/main.tsx"
});
const $43695f19b459f7b9$export$bd61ee610c74db6c = ({ children: children = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: "quickstartNudge",
        fallback: children,
        attributes: {
            nudgeId: props.nudgeId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-quickstart-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($43695f19b459f7b9$var$LazyQuickstartNudge, props, children)));

});
parcelRegister("4UsCN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hcE3v');
        const value = parcelRequire('acTQT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hcE3v").then(()=>parcelRequire('acTQT'));
}

});


parcelRegister("82TTj", function(module, exports) {

$parcel$export(module.exports, "useTrackMountedNudgesController", () => $c697d6dfaf0c6847$export$b759b5124fe0d138);

var $eUqFw = parcelRequire("eUqFw");

var $5cLMB = parcelRequire("5cLMB");
const $c697d6dfaf0c6847$export$b759b5124fe0d138 = (nudgeId)=>{
    const [, { addMountedNudge: addMountedNudge, removeMountedNudge: removeMountedNudge }] = (0, $5cLMB.useQuickstartActions)();
    (0, $eUqFw.useEffect)(()=>{
        addMountedNudge(nudgeId);
        return ()=>{
            removeMountedNudge(nudgeId);
        };
    }, [
        addMountedNudge,
        nudgeId,
        removeMountedNudge
    ]);
};

});

const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("4LQ2W", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $afc2b9f6db507620$export$b687eb4905cdc15a);

var $gNXC6 = parcelRequire("gNXC6");
const $afc2b9f6db507620$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $gNXC6.useHasOpened)();
    return hasOpened;
};

});
parcelRegister("gNXC6", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $0e43dfae21db11a2$export$cbaabcded53b5c1f);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4O87B = parcelRequire("4O87B");
const $0e43dfae21db11a2$var$actions = {
    setHasOpened: $4O87B.setHasOpened
};
const $0e43dfae21db11a2$var$initialState = {
    hasOpened: false
};
const $0e43dfae21db11a2$var$Store = (0, $a61MH.createStore)({
    initialState: $0e43dfae21db11a2$var$initialState,
    actions: $0e43dfae21db11a2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $0e43dfae21db11a2$export$cbaabcded53b5c1f = (0, $ggKAj.createHook)($0e43dfae21db11a2$var$Store);

});
parcelRegister("4O87B", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $9011213d2e2509c3$export$c4743c64a7c42294);
const $9011213d2e2509c3$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $9011213d2e2509c3$export$2e2bcd8739ae039 = $9011213d2e2509c3$export$c4743c64a7c42294;

});



parcelRegister("8Uxmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcdb13b6a22868f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $edcdb13b6a22868f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jwmFeedbackNudgeContentSpork: {
        "id": "software-onboarding-nudges--next.jwm-feedback.jwm-feedback-nudge-content-spork",
        "defaultMessage": "Give us your feedback here."
    },
    nudgeCtaFinish: {
        "id": "software-onboarding-nudges--next.jwm-feedback.nudge-cta-finish",
        "defaultMessage": "Finish"
    }
});

});



//# sourceMappingURL=async-feedback-onboarding-nudge.9db311c3.js.map
